import { Card, styled } from '@material-ui/core';
import { theme } from '../theme/mui-theme';

export const CardStyled = styled(Card)({
  display: 'flex',
  flexDirection: 'column',
  rowGap: theme.spacing(1),
  padding: theme.spacing(2),
  boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.1)'
});

export const Title = styled('h3')({
  fontSize: '14px'
});
